module.exports = __webpack_public_path__ + "images/pages/for_business/pc/cv_1_080a499a38122af3a3fcc39cae04b381.jpg";